import { TrackerEngine } from '@/entities/tracking/lib/tracker-engine';
import { ActiveTests } from '@/hooks/providers/useABTest';
import type { AppOperation } from '@/hooks/tracking/useTrackAppBaseSnapshot';
import { PIPE } from '@/utils/constants/common';

/**
 * Takes in a simple key:value object and returns them in the proper format for analytics
 * Used by DirectAB and Experiments (ABTestExperimentsContext) to generate optimizelyExp string for tracking
 *
 * The snapshot merge only preserves variants dataHub already holds, so when dataHub does not
 * exist yet there is nothing to merge — skip the (up to 10s) availability wait rather than
 * stall callers on the per-navigation tracking path (PTVWS-6991: pre-consent regions keep
 * dataHub absent until the banner is actioned).
 */
export async function createOptimizelyExpString(tests: ActiveTests) {
    // Check if we have an existing optimizelyExp populated
    // and ensure existing variants are not lost when generating optimizelyExp
    const snapshot = await TrackerEngine.snapshot(0);
    const existingTestsArr: Array<string> = [];

    if (snapshot) {
        const appOperation = snapshot.app_operation as AppOperation;
        const existingOptimizelyExp = appOperation?.siteInfo?.optimizelyExp;

        if (existingOptimizelyExp) {
            existingTestsArr.push(...existingOptimizelyExp.split(PIPE));
        }
    }

    const testArr: Array<string> = [];
    for (const test in tests) {
        const key = tests[test];
        testArr.push(`${test}:${key}`);
    }

    const allTests = [...new Set([...existingTestsArr, ...testArr])];

    return allTests.join(PIPE);
}
